import React, {ChangeEvent, ChangeEventHandler} from "react";
import {usePlacesWidget} from "react-google-autocomplete";
import {toast} from "react-toastify";
import onChange = toast.onChange;
import {google_api_key} from "../../services/common.services";



export const BARRECA_CENTER = { lat: 41.9035, lng: -87.939980 }; // lat/lng of Barreca
const milesRadius = 125; // approx miles from center point to service
const kmRadius = milesRadius * 1.60934
const defaultBounds = { // a .01 change is close enough 1 km 
    north: BARRECA_CENTER.lat + (kmRadius * .01),
    south: BARRECA_CENTER.lat - (kmRadius * .01),
    east: BARRECA_CENTER.lng + (kmRadius * .01),
    west: BARRECA_CENTER.lng - (kmRadius * .01),
};
const AddressInput: React.FC<{
    onLocation: (p: { lng: number; lat: number }) => void,
    setPlace: (place: any) => void,
    addressMissing?: boolean,
    className: string
    defaultValue?: string
    loadGoogle?: boolean
}> = ({onLocation, setPlace, addressMissing, className, defaultValue = '', loadGoogle = false}) => {
    const cfg: any = {
        onPlaceSelected: place => {
            if(place && place.geometry)
                if (place.geometry?.location) {
                    onLocation({
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng(),
                    });
                }
            setPlace(place);
        },
        options: {
            types: ["address"],
            bounds: defaultBounds,
            strictBounds: true,
        },
    };

    if (loadGoogle) {
        cfg.apiKey = google_api_key;
    }
    const { ref } = usePlacesWidget(cfg);
    return <>
        <input ref={ref} placeholder="Address" defaultValue={defaultValue} className={className + (addressMissing ? ' is-invalid' : '')} />
        {addressMissing && (
            <div className="invalid-feedback">
                This is a required field
            </div>
        )}
    </>
}

export default AddressInput;